import { render, staticRenderFns } from "./view_AntPortuguese.vue?vue&type=template&id=31dd0227&"
import script from "./view_AntPortuguese.vue?vue&type=script&lang=js&"
export * from "./view_AntPortuguese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports